import { render, staticRenderFns } from "./LargeScreen.vue?vue&type=template&id=967adbca&scoped=true"
import script from "./LargeScreen.vue?vue&type=script&lang=js"
export * from "./LargeScreen.vue?vue&type=script&lang=js"
import style0 from "./LargeScreen.vue?vue&type=style&index=0&id=967adbca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "967adbca",
  null
  
)

export default component.exports